// Bundle for the login / registration layout.
import './legacy/globals/jquery';
import './legacy/globals/underscore';
import './legacy/globals/bootstrap';

import 'vendor/jquery.additionals';
import 'jquery-ui/ui/widgets/datepicker';
import 'vendor/passfield.min';

import './legacy/ajax_waiting';
import './legacy/tooltip';
import './password';

$(function() {
  $(".birthpicker").datepicker({
    yearRange: "-65:-18",
    maxDate: "-18y",
    defaultDate: "-18y",
    changeMonth: true,
    changeYear: true,
    dateFormat: "dd-mm-yy"
  });
});
